import { createContext } from 'react';

import { Translation } from 'src/types';

export const LanguageContext = createContext<Translation>({} as Translation);

export const LanguageProvider = LanguageContext.Provider;
